export function parseDateValue(dateString: string): Date | null {
  const normalizedDateString = normalizeIsoDateString(dateString);
  const date = new Date(normalizedDateString);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatTimeAgo(dateString: string): string {
  const date = parseDateValue(dateString);
  if (!date) {
    return "Sin fecha valida";
  }

  const now = new Date();
  const diffInMs = Math.max(0, now.getTime() - date.getTime());
  
  const seconds = Math.floor(diffInMs / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 0) return `hace ${days}d`;
  if (hours > 0) return `hace ${hours}h`;
  if (minutes > 0) return `hace ${minutes}m`;
  return `hace ${seconds}s`;
}

function normalizeIsoDateString(dateString: string): string {
  const value = dateString.trim();
  const isoLocalMatch = value.match(
    /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2})(?:\.(\d+))?(Z|[+-]\d{2}:?\d{2})?$/i,
  );
  if (!isoLocalMatch) {
    return value;
  }

  const [, secondsPart, fraction = "", timezone = "Z"] = isoLocalMatch;
  if (!fraction) {
    return `${secondsPart}${timezone}`;
  }

  return `${secondsPart}.${fraction.slice(0, 3).padEnd(3, "0")}${timezone}`;
}

export function getPriorityLabel(priority: number): string {
  switch (priority) {
    case 0: return 'Baja';
    case 50: return 'Media';
    case 100: return 'Alta';
    default:
      if (priority < 25) return 'Baja';
      if (priority < 75) return 'Media';
      return 'Alta';
  }
}

export function getPriorityColor(priority: number): string {
  switch (priority) {
    case 0: return 'bg-blue-100 text-blue-800';
    case 50: return 'bg-yellow-100 text-yellow-800';
    case 100: return 'bg-red-100 text-red-800';
    default:
      if (priority < 25) return 'bg-blue-100 text-blue-800';
      if (priority < 75) return 'bg-yellow-100 text-yellow-800';
      return 'bg-red-100 text-red-800';
  }
}